import { getGlobalEventsLogs } from '@cian/events-log';
import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ComplaintModal } from 'shared/components/complaint';
import { HASH_URL_COMPLAIN } from 'shared/constants';
import { IState } from 'shared/store';
import { toggleComplainPopup } from 'shared/store/hideOffer';

export const ComplaintModalContainer = () => {
  const dispatch = useDispatch();
  const isComplainOpened = useSelector<IState, boolean>(state => state.hideOffer.isComplainOpened);

  const onComplainPopupOpen = useEventCallback(() => {
    dispatch(toggleComplainPopup(true));
  });

  /**
   * @description
   * Отправляет событие в микрофронт для отписки от модалки жалоб и закрывает модалку
   */
  const onComplainPopupClose = useEventCallback(() => {
    const globalLog = getGlobalEventsLogs();

    globalLog.produce('complaintsModal', { type: 'popup_close', value: true });
  });

  React.useEffect(() => {
    if (window.location.hash === HASH_URL_COMPLAIN) {
      onComplainPopupOpen();
    }
  }, [onComplainPopupOpen]);

  return <ComplaintModal openModal={isComplainOpened} onCloseModal={onComplainPopupClose} />;
};
